module.exports = __webpack_public_path__ + "static/img/backimg4.6d052c5b.png";